module.exports = __webpack_public_path__ + "static/media/hero_decorative-celebration-02.e46059be.mp3";